// extracted by mini-css-extract-plugin
export default {"ad":"AdvertisementForm_ad__oBJJ2","submit":"AdvertisementForm_submit__yk9lK"};